module.exports = __webpack_public_path__ + "static/media/Asset 14LKnee.b7237528.png";